import { render, staticRenderFns } from "./ImageInspo.vue?vue&type=template&id=e062c600&scoped=true&"
import script from "./ImageInspo.vue?vue&type=script&lang=js&"
export * from "./ImageInspo.vue?vue&type=script&lang=js&"
import style0 from "./ImageInspo.vue?vue&type=style&index=0&id=e062c600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e062c600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel})
